import type { CmmdProject, CmmdTask } from "@cmmd-forge/contracts";

import { normalizeWorkItemPrefix } from "./formatWorkItemId";

const NUMERIC_TASK_ID_PATTERN = /^\d+$/;

export function normalizeTaskAnchorId(value: unknown): string | null {
  if (value === null || value === undefined) return null;
  let normalized = String(value).trim().toLowerCase();
  if (normalized.startsWith("cmmd:")) {
    normalized = normalized.slice("cmmd:".length);
  }
  if (normalized.startsWith("task-")) {
    normalized = normalized.slice("task-".length);
  } else if (normalized.startsWith("task:")) {
    normalized = normalized.slice("task:".length);
  }
  return NUMERIC_TASK_ID_PATTERN.test(normalized) ? normalized : null;
}

export function buildTaskWorkItemKeyIndex(
  projects: readonly CmmdProject[],
  tasks: readonly CmmdTask[],
): ReadonlyMap<string, string> {
  const prefixByProjectId = new Map<string, string>();
  for (const project of projects) {
    const prefix = normalizeWorkItemPrefix(project.workItemPrefix);
    if (prefix !== null) prefixByProjectId.set(project.id, prefix);
  }

  const keyByTaskId = new Map<string, string>();
  for (const task of tasks) {
    if (task.projectId === null) continue;
    const taskId = normalizeTaskAnchorId(task.id);
    const prefix = prefixByProjectId.get(task.projectId);
    if (taskId === null || prefix === undefined) continue;
    keyByTaskId.set(taskId, `${prefix}-${taskId}`);
  }
  return keyByTaskId;
}

export function resolveTaskWorkItemKey(
  keyByTaskId: ReadonlyMap<string, string>,
  anchorCmmdId: unknown,
): string | null {
  const taskId = normalizeTaskAnchorId(anchorCmmdId);
  return taskId === null ? null : (keyByTaskId.get(taskId) ?? null);
}
